import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'hd-popconfirm',
  templateUrl: './hd-popconfirm.component.html',
  styleUrls: ['./hd-popconfirm.component.less']
})
export class HdPopconfirmComponent implements OnInit {
  @Input() message: string;
  @Output() confirmOption = new EventEmitter<any>();
  @Output() cancelOption = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }


  cancel(e: any): void{
    this.cancelOption.emit();
  }

  confirm(e: any): void{
    this.confirmOption.emit();
  }

}
